import headerTypes from 'mui/assets/types/headerTypes';

/**
 * Returns type of header that should be rendered based on Contentful data
 *
 * @param {'Yes' | 'Yes (disabled homepage link)' | 'No'} isSimpleNavigation
 *
 * @returns {headerTypes}
 */
function getHeaderType(isSimpleNavigation) {
  switch (isSimpleNavigation) {
    case 'Yes':
      return headerTypes.SIMPLE;
    case 'Yes (disabled homepage link)':
      return headerTypes.SIMPLE_WITHOUT_HOMEPAGE_LINK;
    default:
      return headerTypes.PRIMARY;
  }
}

export default getHeaderType;
